import { render, staticRenderFns } from "./CardUpdateNegotiationAction.vue?vue&type=template&id=15f01632"
import script from "./CardUpdateNegotiationAction.vue?vue&type=script&lang=js"
export * from "./CardUpdateNegotiationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports